import { render, staticRenderFns } from "./ExtraInformation.vue?vue&type=template&id=00332b90&scoped=true&"
import script from "./ExtraInformation.vue?vue&type=script&lang=js&"
export * from "./ExtraInformation.vue?vue&type=script&lang=js&"
import style0 from "./ExtraInformation.vue?vue&type=style&index=0&id=00332b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00332b90",
  null
  
)

export default component.exports